import React from "react";
import PropTypes from "prop-types";
import { createComponent, PropTypes as CKPropTypes } from "../../wayin-react";
import { withContext } from 'react-recompose';
var InvertedProvider = createComponent({
  displayName: "InvertedProvider",
  propTypes: {
    isInverted: CKPropTypes.bool.isRequired
  },
  render: function render(props) {
    return React.Children.only(props.children);
  }
});
export default withContext( // Intentionally using React's PropTypes here because won't get run through our factory
{
  isInverted: PropTypes.bool.isRequired
}, function (_ref) {
  var isInverted = _ref.isInverted;
  return {
    isInverted: isInverted
  };
})(InvertedProvider);
//# sourceMappingURL=is-inverted-provider.js.map